import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Overridable from "react-overridable";
import { Container } from "semantic-ui-react";
import { BaseForm } from "@forms/core/BaseForm";
import SignupFormFields from "./SignupFormFields";
import SignupMessages from "./SignupMessages";

const CONTAINER_ID = "signup-with-local-account-form";
const OVERRIDABLE_ID = "SignupWithLocalAccount.layout";
const CONTAINER_CLASS = "bottom-spaced";
const DEFAULT_ERROR_HEADER = "Registration Error";

const SignupWithLocalAccountLayout = ({
  errorHeader = DEFAULT_ERROR_HEADER,
  errorMessage = "",
  hasError = false,
  successMessage = "",
  hasSuccess = false,
  data,
  buttons,
  onSubmit,
  isSubmitting = false,
  // Add member type props
  memberTypes = [],
  onMemberTypeChange,
}) => {
  const overridableProps = useMemo(
    () => ({
      data,
      buttons,
      onSubmit,
      memberTypes,
      onMemberTypeChange,
    }),
    [data, buttons, onSubmit, memberTypes, onMemberTypeChange]
  );

  const messageProps = useMemo(
    () => ({
      hasError,
      errorHeader,
      errorMessage,
      hasSuccess,
      successMessage,
      isSubmitting,
    }),
    [
      hasError,
      errorHeader,
      errorMessage,
      hasSuccess,
      successMessage,
      isSubmitting,
    ]
  );

  return (
    <Overridable id={OVERRIDABLE_ID} {...overridableProps}>
      <Container fluid id={CONTAINER_ID} className={CONTAINER_CLASS}>
        <BaseForm
          initialValues={data}
          buttons={buttons}
          onSubmit={onSubmit}
          disabled={isSubmitting}
        >
          <SignupFormFields
            isSubmitting={isSubmitting}
            memberTypes={memberTypes}
            onMemberTypeChange={onMemberTypeChange}
          />
          <SignupMessages {...messageProps} />
        </BaseForm>
      </Container>
    </Overridable>
  );
};

SignupWithLocalAccountLayout.propTypes = {
  data: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  buttons: PropTypes.array.isRequired,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  errorHeader: PropTypes.string,
  hasSuccess: PropTypes.bool,
  successMessage: PropTypes.string,
  isSubmitting: PropTypes.bool,
  // Add member type prop types
  memberTypes: PropTypes.array,
  onMemberTypeChange: PropTypes.func,
};

SignupWithLocalAccountLayout.defaultProps = {
  memberTypes: [],
  onMemberTypeChange: () => {},
};

export default SignupWithLocalAccountLayout;
